module.exports = "<store-list class=\"pad-24\"></store-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/eStore/components/home/home.component.html
// module id = ./client-src/app/eStore/components/home/home.component.html
// module chunks = main